<template lang="pug">
    div
        Modal(
            :title="title"
            v-model="isModalShow"
            width="800"
            footer-hide
        )
            Table(border :columns="tableColumns" :data="filteredTableData" row-key="id" v-if="isModalShow" :no-data-text="$t('main.tableNoDataText')" :no-filtered-data-text="$t('main.tableNoFilteredDataText')")
                template(slot-scope="{ row }" slot="showName")
                    span {{$i18n.t(`routesMenu.${row.name}`)}}
                template(slot-scope="{ row }" slot="read")
                    Icon(type="md-checkmark" color="green" size="24" v-if="row.read")
                    Icon(type="md-close" color="red" size="24" v-else)
                template(slot-scope="{ row }" slot="write")
                    Icon(type="md-checkmark" color="green" size="24" v-if="row.write")
                    Icon(type="md-close" color="red" size="24" v-else)
                template(slot-scope="{ row }" slot="other")
                    Row(v-for="(item,index) in Object.keys(row.other||{})" :key="index")
                        Icon(type="md-checkmark" color="green" size="24" v-if="row.other[item]")
                        Icon(type="md-close" color="red" size="24" v-else)
                        span {{ $i18n.t(`rolesmanage.${item}`) }}
        Button(@click="openModal" size="large" icon="md-eye")

</template>
<script>
export default {
    name: "RolePermissionBtn",
    props: ["title", "tableData"],
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            isModalShow: false,
            tableColumns: [
                {
                    title: "Page",
                    key: "name",
                    slot: "showName",
                },
                {
                    title: "Read",
                    key: "read",
                    slot: "read",
                },
                {
                    title: "Write",
                    key: "write",
                    slot: "write",
                },
                {
                    title: "Other",
                    key: "other",
                    slot: "other",
                },
            ],
            filteredTableData: [],
        };
    },
    methods: {
        openModal() {
            this.isModalShow = true;
        },
        setIdAndOpenTableTree() {
            // 給定唯一值id：上一層的名稱＋自己名稱(設置table tree的rowKey)
            this.filteredTableData.map((e) => {
                e.id = e.name;
                e._showChildren = true;
                if (e.children) {
                    e.children.map((ele) => {
                        ele.id = e.name + "-" + ele.name;
                        // if (ele.children) {
                        //     ele._showChildren = true;
                        //     ele.children.map(element => {
                        //         element.id = ele.name + "-" + element.name;
                        //         element.showName = element.name;
                        //     });
                        // }
                    });
                }
            });
        },
    },
    created() {
        this.filteredTableData = this.tableData.filter(Boolean).map((item) => ({
            ...item,
            children: (item.children && item.children.filter((child) => child.read || child.write)) || [],
        }));

        if (this.isModalShow) this.setIdAndOpenTableTree();
    },
    computed: {},
};
</script>



// WEBPACK FOOTER //
// src/components/RolesManage/RolePermissionBtn.vue